/* eslint-disable */

import React from 'react'
interface PaginationProps {
  totalPosts: number
  postsPerPage: number
  paginate: (pgNumb: number) => void
  currentPage: number
}
export default function Pagination(props: PaginationProps) {
  const { totalPosts, postsPerPage, paginate, currentPage } = props
  const pageNumbers: number[] = []

  for (let i = 1; i <= Math.ceil(totalPosts / postsPerPage); i++) {
    pageNumbers.push(i)
  }

  return (
    <nav>
      <ul className="flex justify-center space-x-2">
        {pageNumbers.map(pgNumb => (
          <li key={pgNumb}>
            <div
              onClick={() => paginate(pgNumb)}
              className={`flex items-center justify-center my-2 w-8 h-8 md:w-12 md:h-12 p-2 md:p-4 transition-colors font-bold text-xl rounded-full cursor-pointer ${
                pgNumb == currentPage
                  ? 'bg-brand text-gray-200'
                  : 'bg-gray-200 hover:bg-brand text-brand hover:text-gray-200'
              }`}
            >
              {pgNumb}
            </div>
          </li>
        ))}
      </ul>
    </nav>
  )
}
